module.exports = __webpack_public_path__ + "img/arrow-down-right.4d41d39d.svg";